/* @flow */

import * as React from 'react';

import {Button} from 'shells/button';
import {ButtonMover} from 'shells/button-mover';

import {AiUsagePopover} from './power-ai-usage-popover/ai-usage-popover';

type Props = {|
    variant: 'timeline' | 'zoom',
|};

export function SummaryInfoButton(props: Props) {
    const buttonContainerRef = React.useRef(null);

    return (
        <>
            <div ref={buttonContainerRef}>
                <ButtonMover direction='left' size='normal'>
                    <Button
                        variant='text-primary'
                        onClick={(e: SyntheticEvent<*>) => {
                            e.stopPropagation();
                        }}
                    >
                        What’s this?
                    </Button>
                </ButtonMover>
            </div>
            <AiUsagePopover
                popoverAnchor={buttonContainerRef}
                variant={props.variant}
                location='top-right'
            />
        </>
    );
}
